import React, { useEffect } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import { useUserContext } from '../../context/UserContext';
import { getFormattedMoneyString } from '../../helpers/utils';
import { TransactionsList } from './transactions-list/TransactionsList';
import { Transfer } from './transfer/Transfer';
import { useLayoutContext } from '../../context/LayoutContext';
import transactionAPI from '../../services/API/transactions';
import { BackButton } from '../../components/common/BackButton';
import { PageTitleHeader } from '../../components/common/PageTitleHeader';
import { FeatureNotAvailable } from '../../components/common/feature-not-available/FeatureNotAvailable';
import { BecomeMemberComponent } from '../../components/common/BecomeMemberComponent';
import { MEMBER_SUBSCRIPTION_STATUS } from '../../constants/appConst';

export const MyWallet = () => {
  const { user } = useUserContext();
  const { showNavBar } = useLayoutContext();

  const [transactions, setTransactions] = React.useState([]);
  const [loadingTransactions, setLoadingTransactions] = React.useState(false);
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [showTransactionHistory, setShowTransactionHistory] =
    React.useState(false);
  const isSM = windowWidth <= 991;

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, []);

  React.useEffect(() => {
    setLoadingTransactions(true);
    loadTransactionList();
  }, []);

  const loadTransactionList = () => {
    if (user.id) {
      transactionAPI
        .getTransactions({ user_id: user.id, product_id: null })
        .then((res) => {
          setTransactions(res);
          setLoadingTransactions(false);
        });
    } else {
      setLoadingTransactions(false);
    }
  };

  return (
    <Row
      className='mt-4'
      style={!showNavBar ? { justifyContent: 'center' } : {}}
    >
      {user.member_status !== MEMBER_SUBSCRIPTION_STATUS.CANCELLED ? (
        <Colxx xxs='12' xl={'9'}>
          <Row>
            <Colxx xxs='12' className='mb-4'>
              <>
                <PageTitleHeader
                  className={'mb-0'}
                  title={
                    showTransactionHistory ? 'Transaction History' : 'Wallet'
                  }
                />
                <div className='label mb-3 pt-3 text-center'>
                  <span
                    className='link-text'
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setShowTransactionHistory(!showTransactionHistory);
                    }}
                  >
                    {showTransactionHistory
                      ? 'Back to wallet'
                      : 'View transaction history'}
                  </span>
                </div>
              </>
            </Colxx>
            {showTransactionHistory ? (
              <Colxx xxs='12' className='mb-4'>
                <TransactionsList
                  transactionsData={transactions}
                  loadingTransactions={loadingTransactions}
                  setLoadingTransactions={setLoadingTransactions}
                  loadTransactionList={() => loadTransactionList()}
                  isSM={isSM}
                />
              </Colxx>
            ) : (
              <Colxx xxs='12' className='mb-4'>
                <Transfer
                  loadTransactionList={() => loadTransactionList()}
                  onShowTransactionHistory={() =>
                    setShowTransactionHistory(true)
                  }
                  isSM={isSM}
                />
              </Colxx>
            )}
          </Row>
        </Colxx>
      ) : (
        <BecomeMemberComponent />
      )}
    </Row>
  );
};
